import { gql } from '@apollo/client'
import { useCsvUpload, useMutation } from '@ztechapps/common.hook'
import type { ImportProductWithSpecArgs, Product } from '@ztechapps/common.contract'
import React from 'react'
import type { DropzoneInputProps } from 'react-dropzone'

export const importWithSpecQuery = gql`
  mutation importProductWithSpec($input: ImportProductWithSpecArgs) {
    importProductWithSpec(input: $input) {
      _id
      forSale
      name
      code
      status
      price
      productType
      computedQuantityOnHand
      metadata {
        description
        key
        unit
        value
        _id
      }
    }
  }
`

export type UseImportProductWithSpecResult = {
  getInputProps: () => DropzoneInputProps
  onFileInputClick: () => void
  loading: boolean
  productId: string
  uploadFileInputRef: React.RefObject<HTMLInputElement>
}
export const useImportProductWithSpec = (): UseImportProductWithSpecResult => {
  const [importProductWithSpec, , { loading }] = useMutation<
    { importProductWithSpec: Product },
    ImportProductWithSpecArgs
  >({
    query: importWithSpecQuery,
  })

  const uploadFileInputRef = React.useRef(null)
  const [productId, setProductId] = React.useState(null)

  const onUpload = async (parsedContent: any[][], rawContent: string) => {
    const result = await importProductWithSpec({
      input: {
        rawContent: rawContent,
      },
    })

    const productId = result?.data?.importProductWithSpec?._id

    setProductId(productId)

    //reset the input after the successful upload
    if (uploadFileInputRef?.current?.value) {
      uploadFileInputRef.current.value = null
    }
  }

  const { getInputProps } = useCsvUpload({ onUpload })

  const onFileInputClick = () => {
    uploadFileInputRef?.current?.click?.()
  }

  return {
    getInputProps,
    onFileInputClick,
    loading,
    productId,
    uploadFileInputRef,
  }
}
